import { CampaignStoreItem } from '@givebacks/api/store';
import { createTable } from 'core/Packages';

const AllCampaignsTableInstance = createTable<CampaignStoreItem>();

export { AllCampaignsTableInstance };
